// extracted by mini-css-extract-plugin
export default {"tie":"tie--hA_vu"};